import { appConfig } from '../../../../../../../config/customization';
import {
  imageIconTips,
  customerSupportTopbarSize,
  defaultPaddingLeft
} from '../../../../../../../constants/sizes';
import Device from '../../../../../../../constants/deviceSizes';
import { unitChart, textInput } from '../../../../../../../constants/fonts';

export default {
  activeRowStyle: {
    backgroundColor: appConfig.colors.activeRowColor,
    boxShadow: 'inset -2px 73px 46px -87px rgba(0,0,0,1)'
  },
  imageIcon: {
    width: 'auto',
    height: imageIconTips,
    marginRight: 15
  },
  title: {
    marginLeft: 20,
    fontSize: textInput,
    [Device.mobile]: {
      fontSize: unitChart
    }
  },
  container: {
    height: '100%'
  },
  table: {
    height: `calc(100% - ${customerSupportTopbarSize}px)`
  },
  topbar: {
    padding: '30px 40px 15px',
    [Device.mobile]: {
      padding: 10
    }
  },
  tipWithoutTitle: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    boxSizing: 'border-box',
    padding: `10px ${defaultPaddingLeft}px`,
    borderBottom: `1px solid ${appConfig.colors.bordersGray}`,
    [Device.mobile]: {
      padding: 10
    }
  },
  description: {
    width: '80%',
    textAlign: 'left'
  }
};
